import {action, autorun, computed, makeObservable, observable} from "mobx";
import {MarketingAlertStore, MarketingModalStore} from "./components";
import {MarketingStatus, MarketingTab} from "../../utils/enums";
// TODO: Reemplazar GraphQL con REST API
// import {API} from "aws-amplify";
// import {
//   deleteMarketingCampaign,
//   getCampaigns,
//   getUploadUrlFile,
//   getUrlFile,
//   putCampaignMarketing,
//   putContactsFromList,
//   putCampaignMessage
// } from "../../graphql/queries";
import axios from "axios";
import {v4 as uuidv4} from 'uuid';
import AuditLogStore from "../auditLog/AuditLogStore";
import dayjs from "dayjs";
import RetryStore from "./components/RetryStore";
import MessageStore from "./MessageStore";
import isPastDate from "../../utils/isPastDate";
import utc from "dayjs/plugin/utc";
import AdvancedSettingsStore from "./AdvancedSettingsStore";

dayjs.extend(utc);

class MarketingStore {
  campaigns = [];
  customer = null;
  domains = [];
  agents = [];

  currentCampaign = null;
  currentAgent = null;
  currentTab = null;
  
  messageStore = null;
  retryStore = null;
  auditLogsStore = null;
  advancedSettingsStore = null;

  modal = null;
  alert = null;

  isGetData = false;
  isUpdating = false;
  isDuplicating = false;
  isDeleting = false;
  isUploadFile = false;
  isCanceling = false;
  isCreating = false;
  isPublish = false;
  isLoadTab = false;

  hitl_selection = {};
  
  filters = {
    search: "",
    type: [],
    status: [],
    ownerNames: [],
    ownerIds: []
  }

  constructor() {
    makeObservable(this, {
      campaigns: observable,
      customer: observable,
      domains: observable,
      agents: observable,
      currentCampaign: observable,
      currentAgent: observable,
      currentTab: observable,
      messageStore: observable,
      retryStore: observable,
      auditLogsStore: observable,
      advancedSettingsStore: observable,
      modal: observable,
      alert: observable,
      isGetData: observable,
      isUpdating: observable,
      isDuplicating: observable,
      isDeleting: observable,
      isUploadFile: observable,
      isCanceling: observable,
      isCreating: observable,
      isPublish: observable,
      isLoadTab: observable,
      hitl_selection: observable,
      filters: observable,
      isLoading: computed,
      showRightPreview: computed,
      existingFileContacts: computed,
      validCampaignName: computed,
      init: action,
      setFilter: action,
      onChangeAttributeCampaign: action,
      onOpenModalEditCampaign: action,
      selectCurrentAgent: action,
      setAgents: action,
      setContactFile: action,
      getCampaigns: action,
      newCampaign: action,
      settingCampaign: action,
      selectCampaign: action,
      getCampaign: action,
      saveCampaign: action,
      publishCampaign: action,
      onSave: action,
      deleteCampaign: action,
      cancelCampaign: action,
      cloneCampaign: action,
      confirmDeleteCampaign: action,
      confirmCancelCampaign: action,
      confirmCloneCampaign: action,
      setBillingVariablesFromFile: action,
      setHitlSelection: action,
      fetchCampaigns: action,
      putContacts: action,
      putCampaignMessage: action,
      changeModeCampaign: action,
      confirmChangeModeCampaign: action
    });
    
    this.modal = new MarketingModalStore();
    this.alert = new MarketingAlertStore();
    
    this.currentTab = MarketingTab.Segments;

    // listen when subject changes nad update name campaign
    autorun(() => {
      if (this.messageStore && this.messageStore.currentSubject && this.messageStore.currentSubject.length > 0) {
        this.onChangeAttributeCampaign("name", this.messageStore.currentSubject);
      }
    });
  }

  init({ customer, domains, id = "", isLoadAll = true, isLoadOne = false }) {
    this.customer = customer;
    this.domains = domains;
    this.currentCampaign = null;
    
    isLoadAll && void this.getCampaigns();
    isLoadOne && void this.getCampaign(id);
  }

  setFilter({ search = "", type = [], status = [], ownerNames = [], ownerIds = [] }) {
    this.filters.search = search;
    this.filters.type = type;
    this.filters.status = status;
    this.filters.ownerNames = ownerNames;
    this.filters.ownerIds = ownerIds;
  }
  
  get isLoading() {
    return this.isGetData || this.isUpdating || this.isDuplicating || this.isDeleting || this.isCanceling || this.isUploadFile || this.isCreating || this.isPublish || this.isLoadTab;
  }
  
  get showRightPreview() {
    return false;
    // return this.segmentStore.rulesStore.showRightPreview;
  }
  
  get existingFileContacts() {
    if (!this.currentCampaign) return false;
    return !!this.currentCampaign?.metadata?.uploaded_contact_file;
  }
  
  get validCampaignName() {    
    return !(this.currentCampaign.name && this.currentCampaign.name.trim());
  }

  setHitlSelection(value) {
    if (this.currentCampaign) {
      this.currentCampaign.hitl_selection = value;
    }
  }
  
  onChangeAttributeCampaign(attribute, value) {
    this.currentCampaign[attribute] = value;
  }
  
  selectCurrentAgent(agent) {
    const tmpAgent = this.agents.find(agentData => agentData.id === agent);
    
    if (tmpAgent) {
      this.currentAgent = tmpAgent;
      this.currentCampaign.agent_id = this.currentAgent.id;
    }
  }
  
  setAgents(agents) {
    this.agents = agents;
    
    if (this.currentCampaign && this.agents.length > 0) {
      this.selectCurrentAgent(this.currentCampaign.agent_id);
    }
  }
  
  setBillingVariablesFromFile({ variables, sources }){
    this.messageStore.setVariablesFromFile({ variables, sources });
    this.retryStore.setVariablesFromFile({ variables, sources });

  }
  
  async setContactFile({ file, numberSegments, name, billingVariables, sources }){
    try {
      this.isUploadFile = true;
      
      const baseFile = file.split('_')[0];

      const contactFile = {
        name: `${file}.json`,
        url: `resources/web/${this.customer}/marketing_conversations/${baseFile}/${file}.json`,
      };

      await this.putContacts({
        customer: this.customer,
        name: contactFile.name,
        url: contactFile.url,
      });
      
      this.currentCampaign.contact_file = contactFile;
      this.currentCampaign.metadata.segment_account = numberSegments;
      this.currentCampaign.metadata.uploaded_contact_file = name;
      
      this.setBillingVariablesFromFile({ variables: billingVariables, sources });
    } catch (error) {
      this.modal.show({
          modal: "generalMessageModal",
          title: "Oops!",
          message: "Error upload contact file"
        }
      );
    } finally {
      this.isUploadFile = false;
    }
  }
  
  async onChangeTab(tab) {
    this.isLoadTab = true;
    if(this.currentTab === MarketingTab.Message) {
      const { binding, payload } = await this.messageStore.getPayload({ toDraft: true, toPublish: false });

      this.currentCampaign.metadata.actions[0].binding = binding;
      this.currentCampaign.metadata.actions[0].payload = payload;

      this.retryStore.setCampaign(this.currentCampaign);

      this.currentTab = tab;
    } else {
      this.currentTab = tab; 
    }
    this.isLoadTab = false;
  }
  
  onOpenModalEditCampaign() {
    this.currentCampaign.nameRead = this.currentCampaign.name;
    this.currentCampaign.descriptionRead = this.currentCampaign.description;
    this.currentCampaign.startDateRead = this.currentCampaign.startDate;
    this.currentCampaign.endDateRead = this.currentCampaign.endDate;
    
    this.modal.show({
      modal: "editMarketing",
      title: "",
      message: "",
      icon: "",
      onHandleConfirm: () => {
        delete this.currentCampaign.nameRead;
        delete this.currentCampaign.descriptionRead;
        delete this.currentCampaign.startDateRead;
        delete this.currentCampaign.endDateRead;
      },
      onHandleCancel: () => {
        this.currentCampaign.name = this.currentCampaign.nameRead;
        this.currentCampaign.description = this.currentCampaign.descriptionRead;
        this.currentCampaign.startDate = this.currentCampaign.startDateRead;
        this.currentCampaign.endDate = this.currentCampaign.endDateRead;
        
        delete this.currentCampaign.nameRead;
        delete this.currentCampaign.descriptionRead;
        delete this.currentCampaign.startDateRead;
        delete this.currentCampaign.endDateRead;
      }
    });
  }

 async getCampaigns() {
   try {
     this.isGetData = true;

     const campaignsData = await this.fetchCampaigns({ 
       customer: this.customer, 
       id: "",
     });

     this.campaigns = Array.isArray(campaignsData) && campaignsData.length > 0
       ? [...campaignsData].sort((a, b) => {
         const aActivity = new Date(a.last_modified || a.insert_date);
         const bActivity = new Date(b.last_modified || b.insert_date);
         return bActivity - aActivity;
       })
       : [];
   } catch (error) {
     this.modal.show({
         modal: "generalMessageModal",
         title: "Oops!",
         message: "Error trying get campaigns"
       }
     );
   } finally {
     this.isGetData = false;
   }
  }
  
  selectCampaign(initialData){
    this.currentCampaign = initialData;
  }
  
  async newCampaign({ customer }) {
    try {
      this.isCreating = true;

      const campaignObject = {
        customer,
        name: "New Marketing Campaign",
        start_datetime: dayjs().toISOString(),
        end_datetime: dayjs().add(1, "day").toISOString(),
        status: MarketingStatus.DRAFT,
        metadata: {
          description: "This is a marketing campaign",
          segment_count: 0,
          filters: [],
          actions: [
            {
              action: "send_email",
              id: uuidv4(),
              binding: [],
              payload: [],
            },
          ],
        },
        contact_file: {},
        agent_id: "",
        retries: {},
      };

      const newCampaign = await this.putCampaign({
        customer,
        campaign: campaignObject,
        isDuplicate: false
      });

      this.settingCampaign({ campaignData: newCampaign });
      this.currentTab = MarketingTab.Segments;

      return newCampaign.id;
    } catch (e) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Error creating a new campaign."
      });
    } finally {
      this.isCreating = false;
    }
  }

  async getCampaign(id) {
    try {
      this.isGetData = true;
      this.currentAgent = null;
      
      const campaignData = await this.fetchCampaigns({
        customer: this.customer,
        id,
      });

      this.settingCampaign({ campaignData });
    } catch (error) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Please try again later."
      });
    } finally {
      this.isGetData = false;
    }
  }

  settingCampaign({ campaignData }){    
    campaignData.idRef = `${campaignData.id}`.replaceAll('#', "");
    campaignData.active = campaignData.status === MarketingStatus.ACTIVE || campaignData.status === MarketingStatus.MANUAL;
    campaignData.description = campaignData.metadata?.description;
    campaignData.startDate = campaignData.start_datetime ? dayjs(campaignData.start_datetime) : null;
    campaignData.endDate = campaignData.end_datetime ? dayjs(campaignData.end_datetime) : null;
    campaignData.metadata = campaignData.metadata || {};

    if (campaignData.agent_id) {
      this.selectCurrentAgent(campaignData.agent_id);
    }

    this.auditLogsStore = new AuditLogStore({
      customer: this.customer,
      modalStore: this.modal
    });
    this.retryStore = new RetryStore({
      campaign: campaignData,
      customer: this.customer,
      modalStore: this.modal
    });
    this.messageStore = new MessageStore({
      customer: this.customer,
      campaign: campaignData,
      modalStore: this.modal
    });
    this.advancedSettingsStore = new AdvancedSettingsStore({
      hitl_selection: campaignData.hitl_settings || {},
      owner: campaignData.owner,
      marketingStore: this
    });

    this.selectCampaign(campaignData);
  }

  async saveCampaign({ validateAgent= true }) {
    try {
      this.isUpdating = true;

      if(validateAgent && !this.currentAgent){
        this.modal.show({
          modal: "agentSelection",
          onHandleConfirm: () => {
            void this.saveCampaign({ validateAgent: false });
          },
          onHandleCancel: () => this.onChangeTab(MarketingTab.Overview),
        });
        return;
      }

      this.currentCampaign.status = MarketingStatus.DRAFT;

      await this.onSave({ toDraft: true, toPublish: false });
      await this.getCampaign(this.currentCampaign.id);
    } catch (error) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Please try again later."
      });
    } finally {
      this.isUpdating = false;
    }
  }

  async publishCampaign() {
    this.modal.show({
      modal: "confirmationPublish",
      onHandleConfirm: () => this.onConformPublish({}),
    });
  }
  
  async onConformPublish({ withAdjustedDates = false }) {
    try {
      this.isPublish = true;

      if(!this.currentAgent){
        this.alert.show("showAgentSelection");
        return;
      }

      const thereIsNoEndDate = !this.currentCampaign.endDate;
      const startDateIsPastDate = isPastDate(this.currentCampaign.startDate);

      if (!withAdjustedDates && (thereIsNoEndDate || startDateIsPastDate)) {
        const datePlus10Min = new Date();

        datePlus10Min.setMinutes(datePlus10Min.getMinutes() + 10);

        const datePlus10MinPlus30Days = new Date(datePlus10Min);
        datePlus10MinPlus30Days.setDate(datePlus10MinPlus30Days.getDate() + 30);

        this.currentCampaign.startDateRead = this.currentCampaign.startDate;
        this.currentCampaign.endDateRead = this.currentCampaign.endDate;

        this.currentCampaign.startDate = dayjs(datePlus10Min);
        this.currentCampaign.endDate = dayjs(datePlus10MinPlus30Days);

        this.modal.show({
          modal: "campaignSchedule",
          onHandleConfirm: () => {
            delete this.currentCampaign.startDateRead;
            delete this.currentCampaign.endDateRead;

            void this.onConformPublish({ withAdjustedDates: true });
          },
          onHandleCancel: () => {
            this.currentCampaign.startDate = this.currentCampaign.startDateRead;
            this.currentCampaign.endDate = this.currentCampaign.endDateRead;

            delete this.currentCampaign.startDateRead;
            delete this.currentCampaign.endDateRead;

            this.onChangeTab(MarketingTab.Overview);
          },
        });

        return;
      }

      this.currentCampaign.status = MarketingStatus.ACTIVE;

      await this.onSave({ toDraft: false, toPublish: true });
      await this.getCampaign(this.currentCampaign.id);
    } catch (e) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Campaign has not been saved successfully, Please try again later."
      });
    } finally {
      this.isPublish = false;
    }
  }

  async onSave({ toDraft, toPublish }){
    const { binding, payload, isComplete } = await this.messageStore.getPayload({ toDraft, toPublish });

    if (!isComplete) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Message fields are required, please complete.",
        onHandleConfirm: () => {
          this.onChangeTab(MarketingTab.Message);
          this.messageStore.showRequireFieldsMessage();
        }
      });

      return;
    }

    this.currentCampaign.metadata.actions[0].binding = binding;
    this.currentCampaign.metadata.actions[0].payload = payload;

    this.currentCampaign.retries = this.retryStore.retriesArray.map((version) => {
      const retry = this.retryStore.retries[version];

      retry.variables = retry.variables.map((item) => ({
        ...item,
        variable: `{{${item.variable}}}`,
      }));
      
      delete retry.templateEditorStore;

      return {
        [version]: {
          ...retry,
        }
      }
    });

    const utcStarDate = this.currentCampaign.startDate.utc().toISOString();
    const utcEndDate = this.currentCampaign.endDate.utc().toISOString();

    this.currentCampaign.start_datetime = utcStarDate;
    this.currentCampaign.end_datetime = utcEndDate;

    await this.putCampaign({
      customer: this.customer,
      campaign: this.currentCampaign,
      isDuplicate: false
    });

    this.modal.show({
      modal: "generalMessageModal",
      title: "Success!",
      message: "Campaign has been saved successfully."
    });
  }

  cancelCampaign(dataCampaign) {
    if (dataCampaign !== this.currentCampaign){
      this.selectCampaign(dataCampaign);
    }

    this.modal.show({
      modal: "confirmation",
      title: "Cancel campaign",
      icon: "deleteGray",
      message: "You're about to end the upcoming conversation. Do you want to continue?",
      onHandleConfirm: () => this.confirmCancelCampaign()
    });
  }
  
  deleteCampaign(dataCampaign) {
    this.selectCampaign(dataCampaign);
    this.modal.show({ 
      modal: "confirmation",
      title: "Archive campaign",
      icon: "deleteGray",
      message: "You are about to archive this set of conversations. Once archived, it cannot be restored. Are you sure you want to proceed?",
      onHandleConfirm: () => this.confirmDeleteCampaign()
    });
  }

  cloneCampaign(dataCampaign, showCampaign = false) {
    if (dataCampaign !== this.currentCampaign){
      this.selectCampaign(dataCampaign);  
    }
    
    this.modal.show({
      modal: "confirmation",
      icon: "duplicateOutline",
      title: "Duplicate campaign",
      message: "You are about to duplicate this conversation. This action will create an exact copy of the conversation. Are you sure you want to proceed?",
      onHandleConfirm: () => this.confirmCloneCampaign(showCampaign)
    });
  }

  changeModeCampaign(dataCampaign, mode) {
    if (dataCampaign !== this.currentCampaign){
      this.selectCampaign(dataCampaign);  
    }
    
    this.modal.show({
      modal: "confirmation",
      icon: "duplicateOutline",
      title: "Change mode",
      message: mode === 'auto'
        ? "You are about to change to Automated Mode, this will make the conversation to be sent instantly without review or approval."
        : "You are about to change to Manual Mode, this will make the conversation to be sent after review or approval.",
      onHandleConfirm: () => this.confirmChangeModeCampaign(mode)
    });
  }

  async confirmChangeModeCampaign(mode) {
    try {
      this.isDuplicating = true;
      this.currentCampaign.status = mode === 'auto' ? MarketingStatus.ACTIVE : MarketingStatus.MANUAL;
      this.currentCampaign.metadata.mode = mode;

      await this.putCampaign({
        customer: this.customer,
        campaign: this.currentCampaign,
        isDuplicate: false
      });

      this.modal.show({
        modal: "generalMessageModal",
        title: "Great!",
        message: "The conversation has been changed to " + mode + " mode"
      });

      this.getCampaigns();
    } catch (error) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Error trying change mode campaign"
      });
    } finally {
      this.isDuplicating = false;
    }
  }
  async confirmDeleteCampaign() {
    try {
      this.isDeleting = true;

      await this.delCampaign({
        customer: this.customer,
        id: this.currentCampaign.id
      });

      this.modal.show({
        modal: "generalMessageModal",
        title: "Great!",
        message: "The conversation has been archived successfully!"
      });
      
      void this.getCampaigns();
    } catch (error) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Error trying delete campaign"
      });
    } finally {
      this.isDeleting = false;
    }
  }
  
  async confirmCancelCampaign() {
    try {
      this.isCanceling = true;

      this.currentCampaign.status = MarketingStatus.CANCELLED;
      
      const updatedCampaign = await this.putCampaign({
        customer: this.currentCampaign.customer,
        campaign: this.currentCampaign,
      });

      updatedCampaign.activeCampaign = this.status === MarketingStatus.ACTIVE || this.status === MarketingStatus.MANUAL;
      this.currentCampaign = updatedCampaign;

      void this.getCampaigns();
    } catch (error) {
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Error trying cancel campaign" });
    } finally {
      this.isCanceling = false;
    }
  }
  
  async confirmCloneCampaign(showCampaign = false) {
    try {
      this.isDuplicating = true;
      
      const newCampaign = await this.putCampaign({
        customer: this.currentCampaign.customer,  
        campaign: this.currentCampaign,
        isDuplicate: true
      });
      
      if (!newCampaign) {
        this.modal.show({
          modal: "generalMessageModal",
          title: "Oops!",
          message: "Error to duplicate campaign" });
        return;
      }

      const action = newCampaign.metadata.actions?.filter(action => action.action === 'send_email')[0];
      if (!action) {
        this.modal.show({
          modal: "generalMessageModal",
          title: "Great!",
          message: "The conversation has been duplicated successfully!" });
        return;
      }

      const bodyFilePath = action.payload.filter(field => field.field === 'body').pop();
      const templateFilePath = action.payload.filter(field => field.field === 'template').pop();

      if (!bodyFilePath?.value || !templateFilePath?.value) {
        this.modal.show({
          modal: "generalMessageModal",
          title: "Great!",
          message: "The conversation has been duplicated successfully!" });
        return
      }

      // Generate a unique ID for this action and its files
      const idAction = uuidv4();

      await Promise.all([
        this.duplicateTemplate({
          customer: newCampaign.customer,
          currentFileName: bodyFilePath.value,
          newFileName: `${idAction}.html`,
          type: 'text/html',
        }),
        this.duplicateTemplate({
          customer: newCampaign.customer,
          currentFileName: templateFilePath.value,
          newFileName: `${idAction}.json`,
          type: 'application/json',
        })
      ]);

      // Small delay to ensure S3 consistency
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // set template files to campaign
      newCampaign.metadata = {
        ...newCampaign.metadata,
        actions: newCampaign.metadata.actions.map(act => {
          if (act.action === 'send_email') {
            return {
              ...act,
              id: idAction,
              payload: [
                ...act.payload.filter(field => !['body', 'template'].includes(field.field)),
                {field: 'body', value: `${idAction}.html`},
                {field: 'template', value: `${idAction}.json`},
              ]
            };
          }
          return act;
        })
      };

      await this.putCampaign({
        customer: this.currentCampaign.customer,
        campaign: newCampaign,
      });

      this.modal.show({
        modal: "generalMessageModal",
        title: "Great!",
        message: "The conversation has been duplicated and is now available as a separate copy!" });

      void this.getCampaigns();
      
      // Load the duplicated campaign's contents if showCampaign is true
      if (showCampaign) {
        await this.getCampaign(newCampaign.id);
      }
    } catch (error) {
      console.log('error', error);
      this.modal.show({
        modal: "generalMessageModal",
        title: "Oops!",
        message: "Error trying duplicate campaign" });
    } finally {
      this.isDuplicating = false;
    }
  }
  
  async duplicateTemplate({ customer, currentFileName, newFileName, route = "email_templates", type }) {
    const fileCurrentUrl = await this.fetchUrlFile({ customer, name: currentFileName, route });
    const blob = await this.fetchFileBlob({ url: fileCurrentUrl, type });
    
    const uploadUrl = await this.fetchUploadUrlFile({ customer, fileName: newFileName, type, route });
    await this.putFileBlob({ url: uploadUrl, blob, type });
  }
  
  async delCampaign({ customer, id }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: deleteMarketingCampaign,
    //   variables: {
    //     input: {
    //       customer,
    //       id
    //     }
    //   },
    //   authMode :'AMAZON_COGNITO_USER_POOLS'
    // });

    // const responseStatus = response.data?.deleteMarketingCampaign?.statusCode || "500";
    // const data = JSON.parse(response.data?.deleteMarketingCampaign?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("delCampaign: Implementar con REST API");
  }
  
  async fetchUrlFile({
    customer,
    name,
    route,
  }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: getUrlFile,
    //   variables: {
    //     input: {
    //       customer,
    //       file_name: name,
    //       file_route: route,
    //     },
    //   },
    //   authMode: 'AMAZON_COGNITO_USER_POOLS'
    // });

    // const responseStatus = response.data?.getUrlFile?.statusCode || "500";
    // const data = JSON.parse(response.data?.getUrlFile?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("fetchUrlFile: Implementar con REST API");
  }
  
  async fetchFileBlob({ url, type }) {
    const res = await axios({
      url,
      method: 'GET',
      responseType: 'blob',
      validateStatus: function (status) {
        return status >= 200 && status < 300;
      }
    });

    if (!res.data) {
      throw new Error("Could not read the template content");
    }

    return new Blob([res.data], {type});
  }
  
  async fetchUploadUrlFile({ customer, fileName, type, route }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: getUploadUrlFile,
    //   variables: {
    //     input: {
    //       customer,
    //       file_name: fileName,
    //       file_type: type,
    //       file_route: route,
    //       overwrite: true
    //     },
    //   },
    //   authMode: 'AMAZON_COGNITO_USER_POOLS'
    // });

    // const responseStatus = response.data?.getUploadUrlFile?.statusCode || "500";
    // const data = JSON.parse(response.data?.getUploadUrlFile?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("fetchUploadUrlFile: Implementar con REST API");
  }
  
  async putFileBlob({ url, blob, type }) {
    const config = {
      headers: {
        "Content-Type": type,
      },
    };

    const uploadResponse = await axios.put(url, blob, config);

    if (uploadResponse.status !== 200) {
      throw new Error(`Could not save the new template (Status: ${uploadResponse.status})`);
    }
  }
  
  async putCampaign({ customer, campaign, isDuplicate = false }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: putCampaignMarketing,
    //   variables: {
    //     input: {
    //       customer,
    //       id: isDuplicate ? undefined : campaign.id || undefined,
    //       name: `${isDuplicate ? 'Copy of ' : ''}${campaign.name}`,
    //       start_datetime: campaign.start_datetime,
    //       end_datetime: campaign.end_datetime,
    //       status: isDuplicate ? MarketingStatus.DRAFT : campaign.status || MarketingStatus.DRAFT,
    //       metadata: JSON.stringify(campaign.metadata),
    //       contact_file: JSON.stringify(campaign.contact_file),
    //       agent_id: campaign.agent_id,
    //       retries: JSON.stringify(campaign.retries),
    //       hitl_selection: JSON.stringify(campaign.hitl_selection || {})
    //     }
    //   },
    //   authMode :'AMAZON_COGNITO_USER_POOLS'
    // });

    // const responseStatus = response.data?.putCampaignMarketing?.statusCode || "500";
    // const data = JSON.parse(response.data?.putCampaignMarketing?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("putCampaign: Implementar con REST API");
  }

  async fetchCampaigns({ customer, id }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: getCampaigns,
    //   variables: { input: { customer, id } },
    //   authMode: "AMAZON_COGNITO_USER_POOLS",
    // });

    // const responseStatus = response.data?.getCampaigns?.statusCode || "500";
    // const data = JSON.parse(response.data?.getCampaigns?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("fetchCampaigns: Implementar con REST API");
  }

  async putContacts({ customer, name, url }) {
    // TODO: Reemplazar GraphQL con REST API
    // const response = await API.graphql({
    //   query: putContactsFromList,
    //   variables: {
    //     input: {
    //       customer: customer,
    //       contact_file: {
    //         name,
    //         url,
    //       },
    //     },
    //   },
    //   authMode: "AMAZON_COGNITO_USER_POOLS",
    // });

    // const responseStatus = response.data?.putContactsFromList?.statusCode || "500";
    // const data = JSON.parse(response.data?.putContactsFromList?.body);

    // if (responseStatus !== "200"){
    //   throw new Error(data.error);
    // }

    // return data;
    throw new Error("putContacts: Implementar con REST API");
  }

  async putCampaignMessage(messageId, campaignId, updatedMessage) {
    try {
      // Clean up the message content
      let messageContent = updatedMessage;
      
      // If it's a JSON string, parse it and extract the message
      if (typeof updatedMessage === 'string' && updatedMessage.startsWith('{')) {
        try {
          const parsed = JSON.parse(updatedMessage);
          if (parsed.message) {
            messageContent = parsed.message;
          }
        } catch (e) {
          // If parsing fails, use the original message
        }
      }

      // Clean up newlines to use standard format
      messageContent = messageContent.replace(/\\n/g, '\n').replace(/\n\n/g, '\n');

      // TODO: Reemplazar GraphQL con REST API
      // const response = await API.graphql({
      //   query: putCampaignMessage,
      //   variables: {
      //     message_id: messageId,
      //     campaign_id: campaignId,
      //     updated_message: messageContent
      //   },
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });

      // // Check if we have a response and it has the expected structure
      // if (!response?.data?.putCampaignMessage) {
      //   throw new Error('Invalid response from server');
      // }

      // const { statusCode, body } = response.data.putCampaignMessage;

      // // Only try to parse body if it's a string and looks like JSON
      // let data = body;
      // if (typeof body === 'string' && (body.startsWith('{') || body.startsWith('['))) {
      //   try {
      //     data = JSON.parse(body);
      //   } catch (e) {
      //     // Silent fail if parsing fails
      //   }
      // }

      // if (statusCode !== "200") {
      //   throw new Error(data?.error || 'Unknown error occurred');
      // }

      // return data;
      throw new Error("putCampaignMessage: Implementar con REST API");
    } catch (error) {
      throw error;
    }
  }
}

export default MarketingStore;
